module.exports = __webpack_public_path__ + "static/media/29.82800c71.png";